import React from "react";
import logo from "./logo.svg";
import "./App.css";
import AppRoutes from "./containers/AppRoutes";
import GlobalStyle from "./globalStyles";
import DashBoard from "./pages/DashBoard";

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
